import { DealService } from '@spilca/order_ts/v1/order_web/deal_web_pb_service';
import { getDealsRequestConstructor } from '@monorepo/deals';

const getDealList = (filter: object | undefined) =>
  getDealsRequestConstructor(filter, DealService.ListDeal);

export default getDealList;
